import CIMSSelect from '../..'
import { useReportRecordSelectContext } from './ReportRecordSelectContext'
import { ReportRecordSelectProps } from './types'

/**
 * a complex {@link CIMSSelect} for Report Records
 *
 * the ReportSelectContext must appear above this component
 */
const ReportRecordSelect: React.FC<ReportRecordSelectProps> = ({
  report,
  ...props
}) => {
  const { options, loading, placeholder, allOptions } =
    useReportRecordSelectContext()
  return (
    <CIMSSelect
      {...props}
      placeholder={report === 'all' ? undefined : placeholder(report)}
      options={
        report === 'all' ? allOptions : report ? options(report.classType) : []
      }
      loading={loading}
    />
  )
}

export default ReportRecordSelect
